import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, TextField, Button, Typography, Box,Dialog,DialogContent } from "@mui/material";
import apiClient from './api/apiClient';
const GOOGLE_CLIENT_ID = "641912731225-s8kted7gdfk304tf3pk63tnuk3dgv77g.apps.googleusercontent.com";
const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [showGoogleDialog, setShowGoogleDialog] = useState(false);
  const handleLogin = async () => {
    // You can add authentication logic here
    if (email && password) {
        let response = await apiClient.post('/auth/login',{email:email,password:password});
        console.log("Response is ",response);
        if(response.data.token){
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('name', response.data.name);
          localStorage.setItem('email', response.data.email);
          localStorage.setItem('userId', response.data.userId);
          localStorage.setItem('screenAccess', response.data.screenAccess);
          window.dispatchEvent(new Event("screenAccessUpdated"));
//          const roleRes = await apiClient.get(`/users/${response.data.userId}/role`);
//          const role = roleRes.data;
//          console.log("User role:", role);
  
//          if (response.data.roleId === 14) {
          if(response.data.email ==="support@utkrusht.com"){
            setShowGoogleDialog(true);
          } else {
            navigate("/home");
          }
//          navigate("/home")
        }else{
          alert("Validation Failed.Please enter correct email and password");
        }
/*      if(email != "manjunath.srikantiah@utkrusht.com" && password != "manju@123"){
        alert("Please enter both correct email and password.");
      }else{
        navigate("/home"); // Navigate to Home page
      }*/
    } else {
      alert("Please enter both email and password.");
    }
  };

  const handleGoogleConnect = () => {
    setShowGoogleDialog(false);

    const oauthUrl = `https://accounts.google.com/o/oauth2/v2/auth?${new URLSearchParams({
      client_id: GOOGLE_CLIENT_ID,
      redirect_uri: "https://adv.vibrantscreen.in/oauth2callback",
      //`${window.location.origin}/oauth2callback`,
      response_type: "token",
      scope: "https://www.googleapis.com/auth/calendar.events",
      include_granted_scopes: "true",
      prompt: "consent",
    })}`;

    window.location.href = oauthUrl;
  };


  return (
    <Container maxWidth="xs">
      <Box
        sx={{
          mt: 10,
          p: 4,
          borderRadius: 2,
          boxShadow: 3,
          textAlign: "center",
        }}
      >
        <Typography variant="h5" gutterBottom>
          Login
        </Typography>
        <TextField
          label="Email"
          type="email"
          fullWidth
          margin="normal"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <TextField
          label="Password"
          type="password"
          fullWidth
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2 }}
          onClick={handleLogin}
        >
          Login
        </Button>
      </Box>
 {/* Google OAuth dialog */}
     <Dialog open={showGoogleDialog} onClose={() => setShowGoogleDialog(false)}>
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            p: 3,
          }}
        >
          <Typography variant="h6" gutterBottom>
            Link Google Calendar
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            To schedule meetings seamlessly, please connect your Google Calendar.
          </Typography>
          <Button variant="contained" color="primary" onClick={handleGoogleConnect}>
            Connect with Google
          </Button>
        </DialogContent>
      </Dialog>


    </Container>
  );
};

export default Login;
